function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export class Client {
  constructor() {
    _defineProperty(this, "status", 'disconnected');

    _defineProperty(this, "connector", void 0);
  }

  get isConnected() {
    return this.status === 'connected';
  }

  async connect({
    chainId,
    connector
  }) {
    this.connector = connector;
    this.status = 'connecting';
    await connector.connect({
      chainId
    });
    this.status = 'connected';
  }

  async disconnect() {
    if (this.connector) await this.connector.disconnect();
    this.connector = undefined;
    this.status = 'disconnected';
  }

}
export let client;
export function createClient() {
  const client_ = new Client();
  client = client_;
  return client_;
}
export function getClient() {
  if (!client) {
    throw new Error('No client found');
  }

  return client;
}